'use strict';

/**
 * Default base for input components.
 */
module.exports = {
    props: {
        context: {
            type: Object,
            required: true
        },

        listeners: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        attributes() {
            return this.context.element.attributes;
        },

        elementAttributes() {
            const attributes = {};
            if (this.attributes.readOnly) {
                attributes['readOnly'] = true;
            }

            return attributes;
        },

        type() {
            if (this.context.element.elementType) {
                return this.context.element.elementDataType || this.context.element.elementType;
            } else {
                return this.context.element.type;
            }
        }
    }
};
